'use client';
import React from 'react';

import { useNavigation } from '@/components/flow/hooks/useNavigation';

import AcneMultiRxUpsell from './components/acneMultiRxUpsell';
import HydroTretMultiRxUpsell from './components/hydroTretMultiRxUpsell';
import { UPSELL_TYPES } from './consts/constants';

const ClientContainer = ({
  cleanserId,
  discountAmountInCents,
  upsells,
}: {
  cleanserId: number | null;
  discountAmountInCents: number | null;
  upsells: string[];
}) => {
  const { onNext } = useNavigation();

  if (upsells.length === 0) {
    onNext();
    return;
  }

  const upsell = upsells[0];

  if (!UPSELL_TYPES[upsell]) {
    onNext();
    return;
  }

  const UpsellComponent = {
    MILD_ACNE_MULTI_RX_UPSELL: AcneMultiRxUpsell,
    HYDROTRET_MULTI_RX_UPSELL: HydroTretMultiRxUpsell,
  }[upsell];

  if (!UpsellComponent) {
    onNext();
    return null;
  }

  return (
    <UpsellComponent
      cleanserId={cleanserId}
      discountAmountInCents={discountAmountInCents}
      upsell={upsell}
    />
  );
};

export default ClientContainer;
